import NudosTextInput from '../../../../../../components/NudosComponents/NudosTextInput/NudosTextInput';
import NudosSelectButton from '../../../../../../components/NudosComponents/NudosSelectButton/NudosSelectButton';
import { IProductDelivery } from '../../../../../../types/orders';
import './OrderSerialsList.scss';

interface OrderSerialsListProps {
  products: IProductDelivery[];
  editProductSerial?: (productId: number, serial: string) => void;
  getErrorText?: (product: IProductDelivery) => string | undefined;
  toggleProductSelection?: (productId: number) => void;
  selectedProductIds?: number[];
  hasStockReservation?: (product: IProductDelivery) => boolean;
  getStockReservationSerial?: (product: IProductDelivery) => string;
  isStockOrder?: boolean;
  requireSerials?: boolean;
}

/**
 * Componente que muestra una lista horizontal de inputs para seriales de productos
 * Permite seleccionar todos los seriales y editar individualmente cada uno
 */
const OrderSerialsList = ({
  products,
  editProductSerial,
  getErrorText,
  toggleProductSelection,
  selectedProductIds = [],
  hasStockReservation,
  getStockReservationSerial,
  isStockOrder,
  requireSerials
}: OrderSerialsListProps) => {
  const allProductIds = products.map(product => product.id);
  const selectedAll = allProductIds.every(productId => selectedProductIds.includes(productId));

  const handleSelectAllChange = (checked: boolean) => {
    if (isStockOrder) return;
    allProductIds.forEach(productId => {
      if (checked && !selectedProductIds.includes(productId)) toggleProductSelection?.(productId);
      if (!checked && selectedProductIds.includes(productId)) toggleProductSelection?.(productId);
    });
  };

  const handleProductSelection = (productId: number, newSerialString: string) => {
    editProductSerial?.(productId, newSerialString);
  };

  const getProductDataToDisplay = (product: IProductDelivery) => {
    const hasReservation = hasStockReservation?.(product);
    const stockSerial = getStockReservationSerial?.(product);
    const isRequired = !hasReservation && !product?.serial && requireSerials;
    const labelText = hasReservation ? 'Serial de stock' : `Serial${isRequired ? '*' : ''}`;
    return { hasReservation, stockSerial, labelText };
  };

  return (
    <div className="orderSerialsList">
      <div
        className={`selectAllSection ${isStockOrder ? 'disabled' : ''}`}
        onClick={() => !isStockOrder && handleSelectAllChange(!selectedAll)}
      >
        <NudosSelectButton isButtonActive={selectedAll} iconName="xmark" colorPalette="black" componentSize="small" />
        <span> Seleccionar todos los seriales</span>
      </div>

      <div className="dividerLine" />

      <div className="productsList">
        {products?.map(product => {
          const { hasReservation, stockSerial, labelText } = getProductDataToDisplay(product);
          const isProductButtonSelected = !!selectedProductIds?.includes(product?.id);
          const isDeactivated = !isProductButtonSelected || (isStockOrder && !requireSerials) || hasReservation;
          const serialInputDefaultVale = hasReservation ? stockSerial : product?.serial;

          return (
            <div key={product?.id} className={`productItem ${isStockOrder ? 'disabled' : ''}`}>
              <div className="productButton">
                <NudosSelectButton
                  isButtonActive={isProductButtonSelected}
                  handleClickButton={() => !isStockOrder && toggleProductSelection?.(product?.id)}
                  iconName="xmark"
                  colorPalette="black"
                  componentSize="small"
                />
                <span>{labelText}</span>
              </div>

              <NudosTextInput
                customClassName="customSerialInput"
                placeholder="Escribe el serial"
                isFilled={!!product?.serial}
                handleChange={value => handleProductSelection?.(product?.id, value)}
                defaultValue={serialInputDefaultVale}
                errorText={getErrorText?.(product)}
                componentSize="medium"
                isDeactivated={isDeactivated}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderSerialsList;
